import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ReactNode } from "react";

interface FormSelectProps {
  name: string;
  label: string;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  options: { label: string; value: string }[];
  touched?: Record<string, unknown>;
  errors?: Record<string, unknown>;
  disabled?: boolean;
  required?: boolean;
}

const FormSelect = ({
  name,
  label,
  value,
  onChange,
  options,
  touched,
  errors,
  disabled = false,
  required = false,
}: FormSelectProps) => {
  const hasError = touched?.[name] && errors?.[name];
  const errorMessage = errors?.[name] as ReactNode;

  return (
    <FormControl
      fullWidth
      error={!!hasError}
      required={required}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={label}
      >
        {options.length === 0 ? (
          <MenuItem
            disabled
            value=""
          >
            No options available
          </MenuItem>
        ) : (
          options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))
        )}
      </Select>
      {hasError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default FormSelect;
